<h1 class="pb-5">{{ 'PAGES.title' | translate: { count: 0 } }}</h1>

<div class="bp-button-tab mb-5">
  <a mat-button class="bp-button" [routerLink]="['settings' | localize]" routerLinkActive="active-link">{{ 'COMMON.settings' | translate }}</a>
  <button mat-button class="bp-button" [routerLink]="['sections' | localize]" routerLinkActive="active-link" [disabled]="disableSections">{{ 'COMMON.sections' | translate }}</button>
</div>

<router-outlet></router-outlet>
